var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80575 2.0562L17.6522 9.6717C17.711 9.70407 17.7601 9.75163 17.7942 9.80941C17.8284 9.8672 17.8464 9.93308 17.8464 10.0002C17.8464 10.0673 17.8284 10.1332 17.7942 10.191C17.7601 10.2488 17.711 10.2963 17.6522 10.3287L3.80575 17.9442C3.74866 17.9756 3.68436 17.9916 3.6192 17.9906C3.55405 17.9896 3.49028 17.9716 3.43418 17.9385C3.37809 17.9053 3.3316 17.8581 3.2993 17.8015C3.267 17.7449 3.25001 17.6809 3.25 17.6157V2.3847C3.25001 2.31954 3.267 2.2555 3.2993 2.1989C3.3316 2.14231 3.37809 2.0951 3.43418 2.06194C3.49028 2.02879 3.55405 2.01082 3.6192 2.00981C3.68436 2.0088 3.74866 2.02479 3.80575 2.0562ZM4.75 10.7502V15.713L15.1375 10.0002L4.75 4.28745V9.2502H8.5V10.7502H4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPlane);
export default __webpack_public_path__ + "static/media/send_plane.50f6f9fd4b07067fbec7c69d71dfe2ba.svg";
export { ForwardRef as ReactComponent };